export const trackedPlayers =
[
    [
        {name: "hleV", color: "bg-teal-500"},
        {name: "RadiCaL", color: "bg-sky-500"},
        {name: "Bambukas", color: "bg-violet-500"}
    ],
    [
        {name: "hleV", color: "bg-teal-500"},
        {name: "RadiCaL", color: "bg-sky-500"},
        {name: "Bambukas", color: "bg-violet-500"}
    ],
    [
        {name: "hleV", color: "bg-teal-500/50"},
        {name: "RadiCaL", color: "bg-sky-500/50"},
        {name: "Uzsipisk grabais", color: "bg-fuchsia-500/50"}
    ],
    [
        {name: "hleV", color: "bg-teal-500"},
        {name: "RadiCaL", color: "bg-sky-500"},
        {name: "Bambukas", color: "bg-violet-500"}
    ],
];
